import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import MainNavbar from "./components/Navbar/MainNavbar";
import Portfolio from "./pages/Portfolio";
import Blog from "./pages/Blog";
import AOS from 'aos';
import 'aos/dist/aos.css';

import "./styles/global.css";

// Inline ScrollToTop component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function AppContent() {
  return (
    <>
      <ScrollToTop />
      <div className="App">
        <MainNavbar />
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
        </Routes>
      </div>
    </>
  );
}

function App() {
  useEffect(() => {
    // Initialize AOS animations with mobile-optimized settings
    AOS.init({
      duration: window.innerWidth <= 768 ? 300 : 800,
      easing: 'ease-out-cubic',
      once: true,
      offset: 50,
      delay: 50,
      disable: window.innerWidth < 480 ? 'mobile' : false
    });

    // Ensure proper viewport meta tag
    const metaViewport = document.querySelector('meta[name="viewport"]');
    if (!metaViewport) {
      const viewport = document.createElement('meta');
      viewport.name = 'viewport';
      viewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';
      document.head.appendChild(viewport);
    } else {
      // Update existing viewport meta tag for better mobile experience
      metaViewport.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover';
    }
    
    // Simple mobile optimizations that don't interfere with React
    if (window.innerWidth <= 768) {
      // Viewport height fix
      const setVH = () => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
      };
      setVH();
      window.addEventListener('resize', setVH);
      
      console.log('Basic mobile optimizations initialized');
    }
    
    // Add mobile-specific body classes
    if (window.innerWidth <= 768) {
      document.body.classList.add('mobile-device');
      if (window.innerWidth <= 480) {
        document.body.classList.add('small-mobile');
      }
    }
    
    // Handle orientation change for mobile
    const handleOrientationChange = () => {
      if (window.innerWidth <= 768) {
        setTimeout(() => {
          const vh = window.innerHeight * 0.01;
          document.documentElement.style.setProperty('--vh', `${vh}px`);
        }, 100);
      }
    };
    
    window.addEventListener('orientationchange', handleOrientationChange);
    window.addEventListener('resize', handleOrientationChange);
    
    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
      window.removeEventListener('resize', handleOrientationChange);
    };
  }, []);

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
